<!-- Navigation -->
<treo-vertical-navigation class="theme-dark"
                          [appearance]="navigationAppearance"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [opened]="!isScreenSmall">

  <div treoVerticalNavigationContentHeader>
    <div class="logo">
      <app-logo></app-logo>
    </div>
  </div>

</treo-vertical-navigation>

<!-- Wrapper -->
<div class="wrapper">

  <!-- Header -->
  <div class="header">

    <!-- Navigation toggle button -->
    <button class="navigation-toggle-button"
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'menu'"></mat-icon>
    </button>

    <!-- Navigation appearance toggle button -->
    <button class="navigation-appearance-toggle-button"
            [ngClass]="{mirror: navigationAppearance === 'dense'}"
            mat-icon-button
            (click)="toggleNavigationAppearance()">
      <mat-icon [svgIcon]="'menu_open'"></mat-icon>
    </button>

    <!-- Spacer -->
    <div class="spacer"></div>

    <!-- Search -->
    <search [appearance]="'bar'"></search>

    <!-- Shortcuts -->
    <shortcuts></shortcuts>

    <!-- Messages -->
    <messages></messages>

    <!-- Notifications -->
    <notifications></notifications>

    <!-- User -->
    <user></user>

  </div>

  <!-- Content -->
  <div class="content">

    <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
         it won't register the changes on the layout and won't update the view. -->
    <router-outlet *ngIf="true"></router-outlet>
    <ngx-loader [fullScreen]="true" name="ball-atom"></ngx-loader>

  </div>

  <!-- Footer -->
  <div class="footer">
    <app-footer></app-footer>
  </div>

</div>
